/**
 * 是否移动端
 */
export const isMobile = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /(android|iphone|ipod|ipad|mobile)/i.test(ua);
};

/**
 * 是否Iphone/IOS
 */
export const isIphoneIos = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /(iphone|ipad)/i.test(ua);
};

/**
 * 是否钉钉
 */
export const isDingTalk = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /dingtalk/i.test(ua);
};

/**
 * 是否企业微信
 */
export const isWxWork = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /wxwork/i.test(ua);
};

/**
 * 是否微信浏览器
 */
export const isWeixin = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
};

/**
 * 是否微信小程序环境
 */
export const isMiniProgram = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /miniProgram|miniprogram/i.test(ua);
};
/**
 * 是否PC端
 */
export const isPc = () => {
  const ua = navigator.userAgent.toLowerCase();
  return !/mobile/i.test(ua);
};

export const isHarmonyOs = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /openharmony/i.test(ua);
};

export default {
  isMobile,
  isIphoneIos,
  isDingTalk,
  isWxWork,
  isWeixin,
  isMiniProgram,
  isPc,
  isHarmonyOs,
};
